











































import demo1 from './demo1.vue';
import demo2 from './demo2.vue';
import demo3 from './demo3.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import MCarousel from '@/packages/m-carousel';
import title from '../../packages/m-carousel/demo/README.md';
import props from '../../packages/m-carousel/demo/props.md';

Vue.use(Anchor);
Vue.use(MCarousel);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1, demo2, demo3
  }
})
export default class ComponentDemo extends Vue {
  public title = title;
  public props = props;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
